import { JubjubLibraryAddresses } from "../../app/src//typechain/factories/contracts/Jubjub__factory";

export const Libs: JubjubLibraryAddresses = {
  ["contracts/poseidon/PoseidonT3.sol:PoseidonT3"]:
    "0x8476a04Df36AB0E922E92aB3bbE4E311a5dc7109",
  ["contracts/poseidon/PoseidonT4.sol:PoseidonT4"]:
    "0xECB11C4a4C91212bBe00569CCB299799840662AF",
  ["contracts/poseidon/PoseidonT5.sol:PoseidonT5"]:
    "0xafCbc06A755557484eeCb54E29661a2450246ECA",
  ["contracts/poseidon/PoseidonT6.sol:PoseidonT6"]:
    "0x802793d904dD09a87DC42266C7FE92e965C0f93D",
};

// 팩토리 주소 넣기!!!!!
export const JubjubFactoryAddress =
  "0xE61363C9404B538A11BC6f9460A74b35933FAB0A";
export const TicketAddress = "0xC1d45AEa7107c2295ca694fcD1AD11823bC75dC6";
